<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Special Voucher</h5>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-button variant="primary" @click="showModalFormSpecialVoucher('create', '')">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button>
        </b-col>
      </b-row>
      <br />
      <!-- <section v-if="table_error">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section> -->
      <b-table
        responsive
        show-empty
        ref="specialVoucherTable"
        :items="getDataSpecialVoucher"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <b-row>
            <b-col md="1"></b-col>
            <b-col md="1">No</b-col>
            <b-col>Voucher Name</b-col>
            <b-col md="1">Action</b-col>
          </b-row>
        </template>
        <template v-slot:cell(selected)="{ item }">
          <draggable
            v-if="special_vouchers.length > 0"
            @change="updateSpecialVoucherOrder()"
            handle=".handle"
            v-model="special_vouchers"
            v-bind="dragOptions"
            group="people"
            :move="onMove">
            <transition-group type="transition" :name="'flip-list'">
              <div v-for="element in special_vouchers" :key="element.id">
                <b-row class="row-field py-2" style="border-bottom: 1px solid #dee2e6;">
                  <b-col md="1">
                    <b-link v-b-tooltip.hover title="Change Order" class="text-dark">
                      <i
                        class="fas fa-bars handle"
                        style="cursor: pointer; font-size: 12px"
                      ></i>
                    </b-link>
                  </b-col>
                  <b-col md="1">{{ element.order }}</b-col>
                  <b-col>{{ element.voucher_name }}</b-col>
                  <b-col md="1">
                    <template>
                      <b-link v-b-tooltip.hover title="Edit" class="text-dark" @click="showModalFormSpecialVoucher('edit', element.id)">
                        <img src="@/assets/ic-edit.svg" class="mr-2" alt />
                      </b-link>
                      <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteSpecialVoucher(element.id, element.voucher_name)">
                        <img src="@/assets/rectangle.svg" class="mr-2" alt />
                      </b-link>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </transition-group>
          </draggable>
          <div v-else role="alert" aria-live="polite">
            <div class="text-center my-2">There are no records to show</div>
          </div>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalFormSpecialVoucherShow"
      size="sm"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">{{editModal ? 'Edit' : 'Create' }} Special Voucher</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              label="Voucher Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="special_voucher.voucher_name"
                v-validate="'required'"
                name="voucher_name"
                data-vv-as="Voucher Name"
                id="voucher_name"
                class="form-control"
                placeholder="Voucher Name"
              />
            <b-form-invalid-feedback id="input-voucher_name-feedback">{{
              veeErrors.first("titvoucher_namele")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              :disabled="loading_form_special_voucher"
              @click="modalFormSpecialVoucherShow = !modalFormSpecialVoucherShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
          <b-col>
            <b-button
              v-if="special_voucher.id != ''"
              variant="primary"
              :disabled="loading_form_special_voucher"
              @click="editSpecialVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_special_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save</span>
            </b-button>
            <b-button
            v-else
              variant="primary"
              :disabled="loading_form_special_voucher"
              @click="createSpecialVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_special_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  data() {
    return {
      table_error: false,
      loading_special_voucher: false,
      loading_form_special_voucher: false,
      modalFormSpecialVoucherShow: false,
      editModal: false,
      special_voucher: {
        id: "",
        voucher_name: "",
        order: 0,
      },
      special_vouchers: [],
      fields: [
        {
          key: "selected",
          class: "",
        }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      editable: true,
      voucher_order_change: {
        id: "",
        order: 1,
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
  },
  methods: {
    getDataSpecialVoucher(ctx, callback) {
      this.loading_special_voucher = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("SpecialVoucherModule/getSpecialVouchersWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.special_vouchers = response.data.data.results || [];
          callback([{selected: "cek"}]);
          this.loading_special_voucher = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get special voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_special_voucher = false;
          callback([]);
        });
      return null;
    },
    showModalFormSpecialVoucher(action, id) {
      this.special_voucher = {
        id: "",
        voucher_name: "",
        order: 0,
      };
      if (action == 'edit') {
        this.$store
        .dispatch("SpecialVoucherModule/getSpecialVoucher", id)
        .then(response => {
          this.special_voucher = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

        this.editModal = true;
      } else {
        this.editModal = false;
      }

      this.modalFormSpecialVoucherShow = !this.modalFormSpecialVoucherShow;
    },
    createSpecialVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_special_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.special_voucher.voucher_name);
          this.$store
            .dispatch("SpecialVoucherModule/postSpecialVoucher", formData)
            .then((response) => {
              this.loading_form_special_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormSpecialVoucherShow = false;
              this.$refs.specialVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store special voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_special_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    editSpecialVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_special_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.special_voucher.voucher_name);
          this.$store
            .dispatch("SpecialVoucherModule/putSpecialVoucher", {
              id: this.special_voucher.id,
              formData
            })
            .then((response) => {
              this.loading_form_special_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormSpecialVoucherShow = false;
              this.$refs.specialVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed edit special voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_special_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    deleteSpecialVoucher(id, voucherName) {
      this.$swal({
        text: `Are you sure want to delete ${voucherName}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("SpecialVoucherModule/deleteSpecialVoucher", id)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              this.$refs.specialVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      this.voucher_order_change = {
        id: draggedElement.id,
        order: draggedContext.futureIndex + 1,
      }
      return(true)
    },
    updateSpecialVoucherOrder() {
      this.$swal({
        title: "Are you sure?",
        text: "You will change order of Special Voucher!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          formData.append("order", this.voucher_order_change.order);
          const payload = {
            id: this.voucher_order_change.id,
            data: formData,
          };
          this.$store
            .dispatch("SpecialVoucherModule/changeOrderSpecialVoucher", payload)
            .then((response) => {
              this.$refs.specialVoucherTable.refresh();
            })
            .catch((error) => {
              this.$refs.specialVoucherTable.refresh();
              this.voucher_order_change = {
                id: "",
                order: 1,
              };
              this.$swal({
                title: "Cannot change order",
                text: error.response.data.message,
                confirmButtonColor: "#6051a2",
                confirmButtonText: "Ok",
              });
            });
        } else {
          this.$refs.specialVoucherTable.refresh();
          this.voucher_order_change = {
            id: "",
            order: 1,
          };
        }
      });
    },
  }
};
</script>

<style scoped>
.row-field:hover{
  color: #858796;
  background-color: rgba(0,0,0,.075);
}
</style>
